window.addEventListener('load', initRichtextToTabs);

function initRichtextToTabs() {
  const productTabsContainer = document.querySelector('[data-product_tabs_container]');
  if (!productTabsContainer) return;
  const richtextContainer = productTabsContainer.querySelector('.metafield-rich_text_field');
  if (!richtextContainer) return;

  const tabsOutput = productTabsContainer.querySelector('[data-tabs]');
  const tabTemplate = productTabsContainer.querySelector('[data-tab_template]');
  if (!tabsOutput || !tabTemplate) return;

  let headingIndex = -1;
  const productTabs = [];
  for (const element of richtextContainer.children) {
    if (element.nodeName.toLowerCase() === 'h3') {
      productTabs.push({ header: element.textContent, content: [] });
      headingIndex++;
      continue;
    }
    if (headingIndex < 0) continue;
    productTabs[headingIndex].content.push(element);
  }
  productTabs.forEach((tab, tabIndex) => renderTab(tab, tabTemplate, tabsOutput, tabIndex));

  productTabsContainer.removeChild(richtextContainer);
  productTabsContainer.removeChild(tabTemplate);
  productTabsContainer.classList.remove('[&>*:first-child]:hidden');
}

function renderTab(data, template, target, index) {
  const tab = template.cloneNode(true);
  const header = tab.querySelector('[data-header]');
  const content = tab.querySelector('[data-content]');
  if (!header || !content) return;

  header.textContent = data.header;
  data.content.forEach((element) => content.appendChild(element));

  tab.classList.remove(tab.dataset.hidden);
  tab.removeAttribute('data-tab_template');
  tab.removeAttribute('data-hidden');
  header.removeAttribute('data-header');
  content.removeAttribute('data-content');

  addTabEvent(tab);
  target.appendChild(tab);

  if (index === 0) {
    const headerLabel = tab.querySelector('.accordion-header');
    headerLabel.click();
  }
}

function addTabEvent(tab) {
  const accordionHeader = tab.querySelector('.accordion-header');
  let accordionContent = accordionHeader.nextElementSibling;
  let plusSign = accordionHeader.querySelector('.plus-sign');
  let collection = accordionHeader.dataset.collection;
  let image = document.querySelector(`.accordion-image#${collection}-image`);
  /* if (accordionHeader.classList.contains('open')) {
    openAccordion();
  } */
  accordionHeader.addEventListener('click', function () {
    const isActive = tab.classList.contains('active');
    const activeTab = tab.parentElement.querySelector('.active');
    if (activeTab) {
      let accordionHeader = activeTab.querySelector('.accordion-header');
      let accordionContent = accordionHeader.nextElementSibling;
      let plusSign = accordionHeader.querySelector('.plus-sign');
      let collection = accordionHeader.dataset.collection;
      let image = document.querySelector(`.accordion-image#${collection}-image`);
      accordionHeader.classList.remove('open');
      accordionContent.classList.add('grid-rows-[0fr]', 'opacity-0');
      accordionContent.classList.remove('grid-rows-[1fr]', 'opacity-100');
      plusSign.classList.remove('opacity-0');
      if (image) {
        image.classList.remove('opacity-100');
        image.classList.add('pointer-events-none');
      }
      activeTab.classList.remove('active');
      if (isActive) return;
    }
    //openAccordion();
    tab.classList.add('active');
    accordionHeader.classList.add('open');
    accordionContent.classList.remove('grid-rows-[0fr]', 'opacity-0');
    accordionContent.classList.add('grid-rows-[1fr]', 'opacity-100');
    plusSign.classList.add('opacity-0');
    if (image) {
      image.classList.add('opacity-100');
      image.classList.remove('pointer-events-none');
    }
  });
}
